<template>
  <div
    class="flex items-center"
    :class="!!left || 'justify-center text-center'"
  >
    <span
      class="h-3 w-3 pr-2 block rounded-full"
      :class="classObject.dot"
    ></span>
    <p class="ml-2" :class="classObject.label">
      <b>{{ status }}</b>
    </p>
  </div>
</template>

<script>
export default {
  props: ["status", "danger", "left"],
  computed: {
    classObject: function () {
      let classes = {
        label: [],
        dot: [],
      };
      switch (this.status) {
        case "Radicada":
          classes.label = ["text-green-500"];
          classes.dot = ["bg-green-500"];
          break;
        case "Error en radicación":
          classes.label = ["text-red-700"];
          classes.dot = ["bg-red-700"];
          break;
        case "Error en radicación de anexo(s)":
          classes.label = ["text-red-700"];
          classes.dot = ["bg-red-700"];
          break;
        case "Servicio deshabilitado":
          classes.label = ["text-gray-500"];
          classes.dot = ["bg-gray-500"];
          break;
      }
      return classes;
    },
  },
};
</script>
